// Restock notify modal logic
(function () {
  var APP_SCRIPT_URL = window.ayaqRestock?.endpoint || '';
  var SUBMIT_COOLDOWN_MS = 15000;
  var detailedErrorsFR = window.Shopify?.locale === 'fr';
  var RECAPTCHA_SITE_KEY = window.ayaqRestock?.captchaSiteKey || window.ayaqRestock?.siteKeyCaptcha || window.ayaqRestock?.siteKey || '';

  function qs(sel, root) { return (root || document).querySelector(sel) }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)) }

  function getVariantData(sectionId) {
    var el = qs('script[data-product-id="product-variants-' + sectionId + '"]');
    if (!el) el = qs('variant-selects script[type="application/json"]');
    if (!el) el = qs('script[data-product-id^="product-variants-"]');
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }

  function getGender() { return window.targetSx || 'unisex'; }

  function disallowByGender(size) {
    var hiddenByGender = { femme: ['XXS', 'XL'], homme: ['XS', 'XXL'] };
    var deny = hiddenByGender[getGender()] || [];
    return deny.indexOf(String(size)) >= 0;
  }

  // Strong DOM fallback: look at the actual size inputs/buttons and their disabled state
  function getUnavailableSizesFromDom() {
    var out = new Set();
    // radio/label pattern
    qsa('input[type="radio"][name="Taille"], input[type="radio"][name*="aille" i]').forEach(function (input) {
      var val = (input.value || '').trim();
      if (!val || disallowByGender(val)) return;
      if (input.disabled) out.add(val);
    });
    // generic disabled buttons with value
    qsa('button[disabled][value]').forEach(function (btn) {
      var val = (btn.getAttribute('value') || btn.textContent || '').trim();
      if (!val || disallowByGender(val)) return;
      out.add(val);
    });
    // legacy unavailable label
    qsa('.unavailable_label').forEach(function (l) {
      var val = (l.getAttribute('data-value') || l.textContent || '').trim();
      if (!val || disallowByGender(val)) return;
      out.add(val);
    });
    return Array.from(out);
  }

  function getUnavailableSizesForCurrentColor(sectionId) {
    var variants = getVariantData(sectionId);
    var colorKey = window.colorOptionName || 'option1';
    var sizeKey = window.sizeOptionName || 'option2';
    var color = window.currentColor;

    if (!variants.length) return getUnavailableSizesFromDom();

    // Try to sync color from selects if missing
    if (!color) {
      var selEl = qs('#Option-' + sectionId + '-0');
      if (selEl && selEl.value) color = selEl.value;
      if (!color && variants[0] && variants[0][colorKey]) color = variants[0][colorKey];
    }

    var unavailable = new Set();
    variants.forEach(function (v) {
      if (color && v[colorKey] !== color) return;
      var size = v[sizeKey];
      if (!size || disallowByGender(size)) return;
      if (!v.available) unavailable.add(size);
    });

    var arr = Array.from(unavailable);
    if (!arr.length) return getUnavailableSizesFromDom();
    // Map for submit
    var map = {}; arr.forEach(function (sz) {
      var match = variants.find(function (v) { return (v[colorKey] === color) && (v[sizeKey] === sz); });
      if (match) map[sz] = match.id;
    });
    window.__restockMap = map;
    return arr;
  }

  function openModal(opener) {
    var modal = qs('#restock-notify-modal');
    if (!modal) return;
    // This protection belongs to restock requests, not browsing or live chat.
    // Start at form opening to be ready before submission; never hide its badge.
    loadRecaptcha(RECAPTCHA_SITE_KEY);
    modal.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // Build sizes
    var sectionId = modal.getAttribute('data-section') || '';
    var sizesWrap = qs('.restock-notify-sizes', modal);
    sizesWrap.innerHTML = '';
    var sizes = getUnavailableSizesForCurrentColor(sectionId);
    sizes.forEach(function (size) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'restock-size';
      b.setAttribute('aria-pressed', 'false');
      b.textContent = size;
      b.addEventListener('click', function () {
        var pressed = b.getAttribute('aria-pressed') === 'true';
        b.setAttribute('aria-pressed', String(!pressed));
        // Update submit button state after size selection
        setTimeout(function () { updateSubmitButtonState(modal); }, 10);
      });
      sizesWrap.appendChild(b);
    });
    var email = qs('#restock-email', modal);
    if (email) email.value = '';
    var fb = qs('.restock-notify-feedback', modal); if (fb) { fb.textContent = ''; fb.className = 'restock-notify-feedback'; }
    var form = qs('#restock-notify-form', modal);
    if (form) {
      form.setAttribute('aria-busy', 'false');
      var submitBtn = qs('button[type="submit"], .button[type="submit"], .button', form);
      if (submitBtn) submitBtn.disabled = true; // Start disabled
    }

    // Add event listeners for real-time validation
    var email = qs('#restock-email', modal);
    if (email) {
      email.addEventListener('input', function () { updateSubmitButtonState(modal); });
      email.addEventListener('blur', function () { updateSubmitButtonState(modal); });
    }
  }

  function closeModal() {
    var modal = qs('#restock-notify-modal');
    if (!modal) return;
    modal.removeAttribute('open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function getSelectedSizes(modal) {
    return qsa('.restock-size[aria-pressed="true"]', modal).map(function (el) { return el.textContent; });
  }

  function updateSubmitButtonState(modal) {
    var form = qs('#restock-notify-form', modal);
    if (!form) return;

    var submitBtn = qs('button[type="submit"], .button[type="submit"], .button', form);
    if (!submitBtn) return;

    var email = qs('#restock-email', modal);
    var emailValue = email ? email.value.trim() : '';
    var sizesSelected = getSelectedSizes(modal);

    var isValidEmail = emailValue && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
    var hasSelectedSizes = sizesSelected.length > 0;

    submitBtn.disabled = !isValidEmail || !hasSelectedSizes;
  }

  function lastSubmissionKey() { var pid = window?.metaProductId || ''; return 'restock-submitted-' + pid; }

  function throttled() {
    var key = lastSubmissionKey();
    var last = parseInt(localStorage.getItem(key) || '0', 10);
    var now = Date.now();
    if (now - last < SUBMIT_COOLDOWN_MS) return true;
    localStorage.setItem(key, String(now));
    return false;
  }

  function decodeEntities(str) {
    try {
      var div = document.createElement('div');
      div.innerHTML = str;
      return div.textContent || div.innerText || '';
    } catch (_) { return String(str || ''); }
  }

  var recaptchaLoad;
  function loadRecaptcha(siteKey) {
    if (!siteKey) return Promise.resolve(false);
    if (recaptchaLoad) return recaptchaLoad;
    recaptchaLoad = new Promise(function (resolve) {
      var script;
      var settled = false;
      var timeout = setTimeout(function () { finish(false); }, 12000);
      function finish(ok) {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        if (!ok && script) script.remove();
        resolve(ok);
      }
      function ready() {
        try {
          if (!window.grecaptcha || !window.grecaptcha.ready) return finish(false);
          window.grecaptcha.ready(function () {
            finish(typeof window.grecaptcha.execute === 'function');
          });
        } catch (_) { finish(false); }
      }
      if (window.grecaptcha && window.grecaptcha.ready) return ready();
      script = document.createElement('script');
      script.src = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(siteKey);
      script.async = true;
      script.defer = true;
      script.onload = ready;
      script.onerror = function () { finish(false); };
      document.head.appendChild(script);
    }).then(function (ok) {
      // Retry only on a subsequent opening/submission, never in a background loop.
      if (!ok) recaptchaLoad = null;
      return ok;
    });
    return recaptchaLoad;
  }

  function getCaptchaToken(siteKey, action) {
    return loadRecaptcha(siteKey).then(function (ok) {
      if (!ok) return '';
      return new Promise(function (resolve) {
        var timeout = setTimeout(function () { resolve(''); }, 12000);
        function finish(token) { clearTimeout(timeout); resolve(token || ''); }
        try {
          Promise.resolve(window.grecaptcha.execute(siteKey, { action: action || 'restock' }))
            .then(finish, function () { finish(''); });
        } catch (_) { finish(''); }
      });
    });
  }

  function submitForm(e) {
    e.preventDefault();
    var modal = e.currentTarget.closest('#restock-notify-modal');
    var fb = qs('.restock-notify-feedback', modal);
    var form = qs('#restock-notify-form', modal);
    if (detailedErrorsFR && form?.getAttribute('aria-busy') === 'true') return;
    if (form) form.setAttribute('aria-busy', 'true');
    if (fb) { fb.textContent = decodeEntities((window.restockI18n || {}).loading || 'Validation en cours…'); fb.className = 'restock-notify-feedback loading'; }
    var submitBtn = qs('button[type="submit"], .button[type="submit"], .button', form || modal);
    if (submitBtn) submitBtn.disabled = true;
    var email = qs('#restock-email', modal)?.value?.trim();
    var sizesSel = getSelectedSizes(modal);
    var honeypot = qs('#restock-website', modal)?.value || '';

    if (honeypot) { return; }
    if (throttled()) { if (fb) { fb.textContent = decodeEntities((window.restockI18n || {}).throttle || 'Veuillez patienter quelques secondes…'); fb.className = 'restock-notify-feedback error'; } if (form) form.setAttribute('aria-busy', 'false'); if (submitBtn) submitBtn.disabled = false; return; }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { if (fb) { fb.textContent = decodeEntities((window.restockI18n || {}).invalid || 'Veuillez saisir un email valide.'); fb.className = 'restock-notify-feedback error'; } if (form) form.setAttribute('aria-busy', 'false'); if (submitBtn) submitBtn.disabled = false; return; }
    if (!sizesSel.length) { if (fb) { fb.textContent = decodeEntities((window.restockI18n || {}).size || 'Sélectionnez une taille.'); fb.className = 'restock-notify-feedback error'; } if (form) form.setAttribute('aria-busy', 'false'); if (submitBtn) submitBtn.disabled = false; return; }

    var productTitle = window?.product_title || document.title;
    var productHandle = (window?.product_handle) || (window?.location?.pathname || '');
    var color = window.currentColor || '';
    var sectionId = modal.getAttribute('data-section') || '';
    var variantIds = sizesSel.map(function (sz) { return (window.__restockMap && window.__restockMap[sz]) ? window.__restockMap[sz] : ''; }).filter(Boolean);

    var payload = {
      email: email,
      product_handle: productHandle,
      product_title: productTitle,
      color: color,
      sizes: sizesSel,
      variant_ids: variantIds,
      locale: (window?.Shopify?.locale) || 'fr',
      site: window?.location?.host || '',
      date_ms: Date.now(),
      section: sectionId
    };

    if (!APP_SCRIPT_URL) { if (fb) { fb.textContent = decodeEntities((window.restockI18n || {}).server || 'Configuration serveur manquante.'); fb.className = 'restock-notify-feedback error'; } if (form) form.setAttribute('aria-busy', 'false'); if (submitBtn) submitBtn.disabled = false; return; }

    // Send via GET with payload to avoid CORS/preflight and redirect body loss
    var url = APP_SCRIPT_URL + (APP_SCRIPT_URL.indexOf('?') === -1 ? '?restock=1' : '&restock=1');
    // Compact query to avoid truncation on redirects
    var qp = [
      'e=' + encodeURIComponent(email),
      'ph=' + encodeURIComponent(productHandle),
      'pt=' + encodeURIComponent(productTitle),
      'color=' + encodeURIComponent(color),
      'locale=' + encodeURIComponent((window?.Shopify?.locale) || 'fr')
    ];
    if (variantIds && variantIds.length) qp.push('vh=' + encodeURIComponent(variantIds.join(',')));
    if (sizesSel && sizesSel.length) qp.push('sizes=' + encodeURIComponent(sizesSel.join(',')));
    Promise.resolve()
      .then(function () { return getCaptchaToken(RECAPTCHA_SITE_KEY, 'restock'); })
      .then(function (token) {
        if (RECAPTCHA_SITE_KEY && !token) {
          var captchaError = new Error('Restock captcha unavailable');
          captchaError.code = 'RESTOCK_CAPTCHA';
          throw captchaError;
        }
        if (token) qp.push('ct=' + encodeURIComponent(token));
        return url + '&' + qp.join('&');
      })
      .then(function (fullUrl) {
        return fetch(fullUrl, { method: 'GET', cache: 'no-cache' })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json().catch(function (error) {
              if (detailedErrorsFR) throw error;
              return { ok: true };
            });
          })
          .then(function (result) {
            if (detailedErrorsFR && (!result || result.ok !== true)) throw new Error('Restock endpoint rejected request');
            return result;
          });
      })
      .then(function () { if (fb) { fb.textContent = decodeEntities((window.restockI18n || {}).success || 'Merci, nous vous notifierons dès le retour en stock.'); fb.className = 'restock-notify-feedback success'; } if (form) form.setAttribute('aria-busy', 'false'); if (submitBtn) submitBtn.disabled = true; setTimeout(closeModal, 3000); })
      .catch(function (error) {
        var messages = window.restockI18n || {};
        var message = detailedErrorsFR && error?.code === 'RESTOCK_CAPTCHA' ? messages.captcha_error : messages.error;
        // A failed French request can be retried immediately; keep the success cooldown.
        if (detailedErrorsFR) {
          try { localStorage.removeItem(lastSubmissionKey()); } catch (_) { }
        }
        if (fb) { fb.textContent = decodeEntities(message || messages.error || 'Une erreur est survenue. Réessayez.'); fb.className = 'restock-notify-feedback error'; }
        if (form) form.setAttribute('aria-busy', 'false');
        if (submitBtn) {
          submitBtn.disabled = false;
          if (detailedErrorsFR && modal.hasAttribute('open') && document.activeElement === document.body) {
            submitBtn.focus({ preventScroll: true });
          }
        }
      });
  }

  function syncCurrentColor(sectionId) {
    var input = document.querySelector('input[name="id"]');
    var colorKey = window.colorOptionName || 'option1';
    try {
      var variants = getVariantData(sectionId);
      if (input && input.value && variants && variants.length) {
        var vid = String(input.value);
        var v = variants.find(function (x) { return String(x.id) === vid; });
        if (v && v[colorKey]) window.currentColor = v[colorKey];
      }
    } catch (_) { }
    var colorSelect = qs('#Option-' + sectionId + '-0');
    if (colorSelect && colorSelect.value) window.currentColor = colorSelect.value;
  }

  function renderCallout(sectionId) {
    var callout = qs('.restock-notify__callout');
    if (!callout) return;
    var sizes = getUnavailableSizesForCurrentColor(sectionId);
    var openerBtn = qs('.restock-opener', callout);
    
    // Store original button text on first call if not already stored
    if (openerBtn && !openerBtn.getAttribute('data-i18n-text')) {
      openerBtn.setAttribute('data-i18n-text', openerBtn.textContent || '');
    }
    
    if (sizes && sizes.length) {
      var msgEl = qs('.restock-msg', callout);
      if (msgEl) {
        // var raw = ((window.restockI18n || {}).callout_dynamic || 'Tailles indisponibles: {{ sizes }}').replace('__SIZES__', sizes.join(', ')).replace('{{ sizes }}', sizes.join(', '));
        // msgEl.textContent = decodeEntities(raw);
      }
      // Update button text with sizes
      if (openerBtn) {
        var buttonText = openerBtn.getAttribute('data-i18n-text') || openerBtn.textContent || '';
        var sizesStr = sizes.join(', ');
        var updatedText = buttonText.replace(/\{\{\s*sizes\s*\}\}/g, sizesStr);
        openerBtn.textContent = decodeEntities(updatedText);
      }
      callout.setAttribute('data-notify', sizes.join(','));
      callout.style.display = 'inline-block';
    } else {
      // Reset button text when no sizes
      if (openerBtn) {
        var originalText = openerBtn.getAttribute('data-i18n-text') || '';
        openerBtn.textContent = decodeEntities(originalText.replace(/\{\{\s*sizes\s*\}\}/g, ''));
      }
      callout.setAttribute('data-notify', '');
      callout.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var opener = qs('.restock-opener');
    var modal = qs('#restock-notify-modal');
    var callout = qs('.restock-notify__callout');
    if (opener && modal) opener.addEventListener('click', function () { openModal(opener); });

    function refreshCallout() { if (!callout || !modal) return; var sectionId = modal.getAttribute('data-section') || ''; syncCurrentColor(sectionId); renderCallout(sectionId); }
    refreshCallout();

    // Update on any option/variant change
    document.addEventListener('click', function (e) { var t = e.target; if (!t) return; if (t.closest('[data-product-variants]') || t.closest('[name^="options["]')) refreshCallout(); });
    document.addEventListener('change', function (e) { var t = e.target; if (!t) return; if (t.name === 'id' || /^options\[/.test(t.name) || (t.id && /Option-.+-0$/.test(t.id))) refreshCallout(); });
    ;['variant:change', 'variant-change', 'product:variant:change', 'variantChanged', 'variantchange'].forEach(function (evt) { document.addEventListener(evt, refreshCallout); });

    if (modal) { var form = qs('#restock-notify-form', modal); if (form) form.addEventListener('submit', submitForm); var closeBtn = qs('#RestockClose', modal); if (closeBtn) closeBtn.addEventListener('click', closeModal); modal.addEventListener('click', function (ev) { var content = qs('.restock-notify-modal__content', modal); if (!content) return; if (ev.target === modal) { closeModal(); } }); document.addEventListener('keydown', function (ev) { if (qs('#restock-notify-modal[open]') && ev.key === 'Escape') closeModal(); }); }
  });
})();


